/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DistributeSkillRequestBody = {
  /**
   * The assistant that carries the skill.
   */
  assistantId?: string | undefined;
  /**
   * The skill ID.
   */
  id: string;
  /**
   * An optional valid version to pin instead of tracking the latest valid version.
   */
  pinnedVersionId?: string | undefined;
  /**
   * The plugin that carries the skill.
   */
  pluginId?: string | undefined;
};

/** @internal */
export type DistributeSkillRequestBody$Outbound = {
  assistant_id?: string | undefined;
  id: string;
  pinned_version_id?: string | undefined;
  plugin_id?: string | undefined;
};

/** @internal */
export const DistributeSkillRequestBody$outboundSchema: z.ZodMiniType<
  DistributeSkillRequestBody$Outbound,
  DistributeSkillRequestBody
> = z.pipe(
  z.object({
    assistantId: z.optional(z.string()),
    id: z.string(),
    pinnedVersionId: z.optional(z.string()),
    pluginId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      assistantId: "assistant_id",
      pinnedVersionId: "pinned_version_id",
      pluginId: "plugin_id",
    });
  }),
);

export function distributeSkillRequestBodyToJSON(
  distributeSkillRequestBody: DistributeSkillRequestBody,
): string {
  return JSON.stringify(
    DistributeSkillRequestBody$outboundSchema.parse(distributeSkillRequestBody),
  );
}
